import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { SingleInput, SingleRedio, SingleSelect } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_getDepartmentList, api_addDepartment } from '../../../../api/apiDepartment';
import { ReqDepartmentList, ReqDepartmentAdd } from '../../../../item/ItemDepartment';


export function DepartmentAdd({ setIsLoading }) {
  const [companyId] = useState(Auth.getUserInfoCompanyId())
  const [departmentName, setDepartmentName] = useState("")
  const [managerDepartmentId, setManagerDepartmentId] = useState("")
  const [managerDepartmentList, setManagerDepartmentList] = useState([])
  const [isDisable, setIsDisable] = useState(1)


  useEffect(() => {
    console.log("TEST")
    var mReqDepartmentList = new ReqDepartmentList({ companyId })
    getDepartmentList(mReqDepartmentList)
  }, [])

  function toCancel() {
    window.history.back();
  }

  async function getDepartmentList(mReqDepartmentList) {
    setIsLoading(true)
    api_getDepartmentList({
      mReqDepartmentList,
      success: (obj) => {
        console.log(obj)
        setManagerDepartmentList(obj.list)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function toAdd() {
    if (departmentName !== "" && managerDepartmentId !== "") {
      var userInfo = Auth.getUserInfo()
      var mReqDepartmentAdd = new ReqDepartmentAdd({
        companyId,
        departmentName,
        managerDepartmentId,
        isDisable
      })
      api_addDepartment({
        mReqDepartmentAdd,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
          }).then(function () {
            setDepartmentName("")
            setManagerDepartmentId("")
            setIsDisable(1)
            //window.history.replace("/ManagerList");
            window.history.back(-1);
          })
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '部門名稱, 上級單位 不得為空',
      })
    }
  }

  const isDisableItems = [
    { "val": 0, "name": "是" },
    { "val": 1, "name": "否" },
  ]

  var title = "部門資訊"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleRedio title={"是否啟用"}
            arr={isDisableItems}
            val={isDisable ? 1 : 0}
            action={setIsDisable}
            size={4}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"部門名稱"} val={departmentName} action={setDepartmentName} placeholder={"管理部、會計部"} size={4} />
          <SingleSelect
            title={"上級單位"}
            val={managerDepartmentId}
            attr={managerDepartmentList}
            action={setManagerDepartmentId}
            v={"departmentId"}
            n={"departmentName"}
            hasBlank={true}
            size={4} />
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}